import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  filter: {
    and: [
      {
        '=': [
          {
            '@_': 'id',
          },
          {
            '@$': 'orgEntityId',
          },
        ],
      },
      {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'orgRecordId',
          },
        ],
      },
    ],
  },
  target: 'dim::!org',
  quantity: 1,
  selection: {
    '{}': {
      name: 'Organization Details',
      type: 'tree-table',
      content: {
        '{}': {
          rows: {
            '??': [
              {
                '@': 'organizationRows',
              },
              {
                '[]': [],
              },
            ],
          },
          rootId: {
            '@.': '!id',
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'numberAssets',
                  direct: {
                    '{}': {
                      name: 'Number of Assets',
                      type: 'INT',
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
  subqueries: {
    organizationRows: {
      target: 'descendants',
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          fields: {
            '{}': {
              name: {
                '{}': {
                  value: {
                    '@.': '!name',
                  },
                },
              },
              numberAssets: {
                '{}': {
                  value: {
                    '#': {
                      '@': 'assets',
                    },
                  },
                },
              },
            },
          },
          parentId: {
            '@^': 'parent',
          },
        },
      },
      subqueries: {
        assets: {
          ref: {
            attr: 'attr:ent#!innovation_asset_offering#!entry:!innovation_asset',
          },
          using: 'assetOffering',
          target: 'ent:!innovation_assets:!innovation_asset',
          filter: {
            '=': [
              {
                '@.': '!ai_enabled',
              },
              true,
            ],
          },
          selection: {
            '@.': '!name',
          },
        },
        offerings: {
          ref: {
            attr: 'attr:ent#!org_offering#!entry:!offering',
            inherit: '-',
          },
          using: 'orgOfferings',
          target: 'dim::!offerings',
          selection: {
            '@.': '!name',
          },
        },
        orgOfferings: {
          ref: {
            attr: 'attr:ent#!org_offering#!entry:!org',
            inherit: '-',
          },
          target: 'dim::!org_offering',
        },
        assetOffering: {
          ref: {
            attr: 'attr:ent#!innovation_asset_offering#!entry:!offering',
          },
          using: 'offerings',
          target: 'dim::!innovation_asset_offering',
        },
      },
    },
  },
}
